import * as React from "react"
import { connect } from "react-redux"
import { GlobalState } from "../../../../store"

import AuthBasePage from "../../AuthBasePage"
import {
    Action,
    ActionAnchor,
    ActionType,
} from "@tenforce/toolbox-button-push-react"
import { FieldItems, Input } from "@tenforce/toolbox-field-react"
import { mapDispatchToProps, DispatchProps } from "../../actions"
import env from "../../../../env"
import { IRecoverPasswordPage } from "../../index"

const applicationPath = env.applicationPath

type StateProps = IRecoverPasswordPage

type Props = StateProps & DispatchProps

interface State {
    email: string
}

export class RecoverPasswordPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { email: this.props.email }
    }

    resetPassword = (event: React.FormEvent<HTMLElement>): void => {
        event.preventDefault()
        this.props.requestRestorePassword(this.state.email)
    }

    render(): JSX.Element {
        const { errorMessage, showSuccess, isLoading } = this.props
        const { email } = this.state

        return (
            <AuthBasePage isLoading={isLoading}>
                <form id="recoverPassword" onSubmit={this.resetPassword}>
                    <h2 className="tw-mx-4 is-inverted tw-mb-1">
                        Forgot your password?
                    </h2>
                    {!!errorMessage && (
                        <div className="theme-bubble bg-cadmium-red text-white tw-px-3 tw-py-1 tw-w-fit ">
                            <h4>Resetting your password was unsuccessful.</h4>
                            <p>{errorMessage}</p>
                        </div>
                    )}
                    {showSuccess ? (
                        <>
                            <div
                                className="theme-bubble bg-white tw-mb-2 tw-px-3 tw-py-1 tw-w-fit"
                                id="recoverSuccessMessage"
                            >
                                <p className="tw-pb-3">
                                    To initiate the password reset process,
                                    please follow the instructions sent to your{" "}
                                    {email} email address.
                                </p>
                                <p>
                                    Please make sure {email} is the email
                                    address you use to login. If it is not, you
                                    will not receive an email to reset your
                                    password.
                                </p>
                            </div>
                            <div>
                                <ActionAnchor
                                    href={applicationPath + "/"}
                                    actionType={ActionType.button}
                                    isLabel={true}
                                >
                                    Go back to the login page
                                </ActionAnchor>
                            </div>
                        </>
                    ) : (
                        <>
                            <FieldItems isInverted={true} label="Email">
                                <Input
                                    id="emailaddress"
                                    name="emailaddress"
                                    autoComplete="on"
                                    autoFocus={true}
                                    required={true}
                                    placeholder="Enter your email"
                                    value={email}
                                    onChangedValue={(email): void =>
                                        this.setState({ email })
                                    }
                                    disabled={isLoading}
                                />
                            </FieldItems>
                            <div>
                                <Action
                                    id="recoverPasswordActionButton"
                                    type="submit"
                                    actionType={ActionType.button}
                                    isLabel={true}
                                    disabled={isLoading}
                                >
                                    Reset password
                                </Action>
                            </div>
                        </>
                    )}
                </form>
            </AuthBasePage>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.auth.recoverPasswordPage

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPasswordPage)
